import {ContextPanelData} from 'common/widgets/context-panel/types';
import {TooltipContextActionResult} from 'common/widgets/query-block/child-menu';
import {Section, SectionItem} from 'common/components/items-menu/types';
import {PropertyType, ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {SpecialTimeUnit, TimeUnit} from 'common/widgets/date-range-picker/models/types';
import {CustomProperty} from 'common/report/stores/custom-properties';
import {Cohort} from 'common/util/definitions-types';
import {User} from 'common/widgets/cohorts-query-builder/models/types/serialized-cohort-types';

export enum PropertiesMenuSectionType {
  Recent = `recent`,
  Event = `event`,
  User = `user`,
  Cohort = `cohort`,
  DataGroup = `dataGroup`,
  Other = `other`,
}
export interface PropertiesMenuSection extends Section {
  sectionType: PropertiesMenuSectionType;
  items: PropertyItem[];
}

export enum PropertyItemAction {
  Typecast = `typecast`,
}

export interface PropertyItem extends SectionItem {
  customPropertyId?: number;
  customProperty?: CustomProperty;
  dimensionDataGroupId?: string;
  tempDataGroupId?: string;
  dataGroupId?: string;
  propertyDefaultType: PropertyType;
  resourceType: ResourceType;
  pillAction?: PropertyItemAction;
  type: PropertyType;
  joinPropertyType?: PropertyType;
  createdBy?: User;
  unit?: TimeUnit | SpecialTimeUnit;
  items?: [any];
  name?: string;
  isLookupTableProperty?: boolean;
}

export const PropertyItemKeys: Array<keyof PropertyItem> = [
  `customPropertyId`,
  `customProperty`,
  `dataGroupId`,
  `dimensionDataGroupId`,
  `tempDataGroupId`,
  `joinPropertyType`,
  `label`,
  `propertyDefaultType`,
  `resourceType`,
  `type`,
  `value`,
  `unit`,
  `items`,
];

// Checked in order
export const PropertyItemPersistedIdentifierKeys: Array<keyof PropertyItem> = [
  `customPropertyId`,
  `tempDataGroupId`,
  `dataGroupId`,
  `value`,
];

export enum PropertyCombineMode {
  Union = `union`,
  Intersection = `intersection`,
}

/**
 * selectedTab can be `all`, a dataGroupId or a resourceType
 */
export type SelectedTab = `all` | string | ResourceType;

export type CohortItem = Cohort & {
  label: string;
  canView?: boolean;
  canUpdateBasic?: boolean;
  canShare?: boolean;
  isSuperadmin?: boolean;
};

// because PropertiesMenu is actually a class that implements this interface
export interface IPropertiesMenu {
  useMultipleSelection: boolean;
  getStagedPropertyType(): StagedMenuTypes;

  getSelectedTab(): SelectedTab;
  getSelectedHoverTooltipData(): ContextPanelData;
  getSelectedTrackingProps(): Obj;
  handleCloseMenu(): void;
  handleTooltipContextAction(ev: Event): TooltipContextActionResult;
  hasOpenedModal(): boolean;
  isContentSearchable(): boolean;
  isInnerContentSearchable(): boolean;
}

export type GetSortedMenuSections = (sections: Section[]) => Section[];

export interface LookupTable {
  id: string;
  name: string;
  token: string;
  createdAt: string;
  lastModifiedAt: string;
}

export enum StagedMenuTypes {
  Typecast,
  Dimension,
  Datetime,
}
